import { create } from 'zustand';
import { parseUrlParams } from '@/utils/tools';

interface IChatStore {
  /** 机器人聊天框是否展示 */
  botVisible: boolean;
  setBotVisible: (visible: boolean) => void;
  /** 窗口吸附状态 */
  windowState: 'full' | 'fixed' | 'float';
  setWindowState: (state: 'full' | 'fixed' | 'float') => void;
  /** 窗口吸附位置 */
  fixedStyle: {
    left: number;
    top: number;
    height: number;
    width: number;
  };
  setFixedStyle: (style: { left: number; top: number; height: number; width: number }) => void;
  /** 历史会话id */
  historySessionId: string;
  setHistorySessionId: (id: string) => void;
  /** 左侧历史会话高亮的活跃 id */
  activeSessionId: string;
  setActiveSessionId: (id: string) => void;
  /** 左侧历史记录ID高亮的活跃 id */ // 弃用，使用activeSessionId替代
  activeHistoryId: string;
  setActiveHistoryId: (id: string) => void;
  /** 是否是新会话 */
  isNewChat: boolean;
  setIsNewChat: (isNew: boolean) => void;
  /** 临时会话记录 */
  tempSessionRecord: any | null;
  /** 创建新的临时会话 */
  createNewTempSession: (tempSessionRecord: any) => void;
  /** 更新临时会话记录 */
  updateTempSession: (record: any | null) => void;
  /** 会话里触发的快捷表单信息 */
  quickFormInfo: any | null;
  /** 更新快捷表单信息 */
  setQuickFormInfo: (record: any | null) => void;
  /** 激活的内容类型 */
  activeContentType: 'chat' | 'subscription' | 'setting';
  /** 设置激活的内容类型 */
  setActiveContentType: (type: 'chat' | 'subscription' | 'setting') => void;
  /** 未读消息数 */
  unReadCount: number;
  /** 设置未读消息数 */
  setUnReadCount: (count: number) => void;
  /** 当前选中的机器人编码 */
  currentRobotCode: string;
  /** 设置当前选中的机器人编码 */
  setCurrentRobotCode: (code: string) => void;
}

export const useChatStore =
  create<IChatStore>((set, get) => {
    const { robotShow, subscriptionId } = parseUrlParams();

    return {
      botVisible: robotShow === 'true',
      setBotVisible: (visible: boolean) => set({ botVisible: visible }),
      windowState: 'full',
      setWindowState: (state: 'full' | 'fixed' | 'float') => set({ windowState: state }),
      fixedStyle: { left: 0, top: 0, height: 0, width: 0 },
      setFixedStyle: (style: { left: number; top: number; height: number; width: number }) => set({ fixedStyle: style }),
      historySessionId: '',
      setHistorySessionId: (id: string) => set({ historySessionId: id }),
      activeSessionId: '',
      setActiveSessionId: (id: string) => set({ activeSessionId: id }),
      activeHistoryId: '',
      setActiveHistoryId: (id: string) => void set({ activeHistoryId: id }),
      isNewChat: true,
      setIsNewChat: (isNew: boolean) => set({ isNewChat: isNew }),
      tempSessionRecord: null,
      setTempSessionRecord: (record: any | null) => set({ tempSessionRecord: record }),
      createNewTempSession: (tempSessionRecord) => set({
        tempSessionRecord,
      }),
      updateTempSession: (record: any | null) => set({ tempSessionRecord: record }),
      quickFormInfo: null,
      setQuickFormInfo: (record: any | null) => set({ quickFormInfo: record }),
      activeContentType: subscriptionId ? 'subscription' : 'chat',
      setActiveContentType: (type: 'chat' | 'subscription' | 'setting') => set({ activeContentType: type }),
      unReadCount: 0,
      setUnReadCount: (count: number) => set({ unReadCount: count }),
      currentRobotCode: '',
      setCurrentRobotCode: (code: string) => set({ currentRobotCode: code }),
    };
  });